import QuizEntryBankEdit from './presenter';
import { connect } from '../../../../../../common/react-redux';
import { changeQuizEntryPoints, changeQuizEntryProperties, changeQuizEntryEntry, clearModifications } from '../../../../../../common/actions/modifications';
import { updateQuizEntry } from '../../../../../api/quizEntries';
export function mapStateToProps(state, props) {
  var workingQuizEntry = props.quizEntry.getWorkingInstance();
  var properties = workingQuizEntry.properties;
  var sampleNum = properties.get('sampleNum');
  var selection = sampleNum > 0 ? 'rand' : 'all';
  return {
    workingBank: workingQuizEntry.getEntry(),
    workingQuizEntry: workingQuizEntry,
    questionSelection: properties.get('selection', selection),
    sampleNum: sampleNum,
    pointsPossible: workingQuizEntry.pointsPossible
  };
}
export default connect(mapStateToProps, {
  changeQuizEntryPoints: changeQuizEntryPoints,
  changeQuizEntryProperties: changeQuizEntryProperties,
  changeQuizEntryEntry: changeQuizEntryEntry,
  clearModifications: clearModifications,
  updateQuizEntry: updateQuizEntry
})(QuizEntryBankEdit);